export const RRN_INPUT_VIEW = 'RRN_INPUT_VIEW';
export const RRN_INPUT = 'RRN_INPUT';
export const RRN_COMPLETE_BUTTON = 'RRN_COMPLETE_BUTTON';
